import {z} from 'zod';

// Nested Schemas

export const personnelOverviewUserSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
});

export const personnelOverviewItemSchema = z.object({
  user: personnelOverviewUserSchema,
  activeCount: z.number(),
});

// Request / Response Body Schemas

export const personnelOverviewArgSchema = z.object({
  branchId: z.string().uuid().optional(),
});

export const personnelOverviewResponseBodySchema = z.array(personnelOverviewItemSchema);

// Exported Types

export type PersonnelOverviewItem = z.infer<typeof personnelOverviewItemSchema>;

export type GetPersonnelOverviewApiArg = z.infer<typeof personnelOverviewArgSchema>;

export type GetPersonnelOverviewApiResponse = z.infer<typeof personnelOverviewResponseBodySchema>;
